/**
 * Selected-organization manager.
 *
 * Mirrors `token-manager` — a module-level holder so the axios client can read
 * the currently selected organization without importing React. The org picker
 * registers a getter; every request then carries `X-Shadow-Org`.
 *
 * The value is a hint from the client, not an authorization: the backend
 * re-checks it against the caller's ShadowAccess record on every request.
 */

type OrgGetter = () => null | string;

let orgGetter: null | OrgGetter = null;

/**
 * Read the currently selected organization code.
 *
 * @returns The org code, or null when nothing is selected yet
 */
export const getSelectedOrgCode = (): null | string => {
	return orgGetter ? orgGetter() : null;
};

/**
 * Register the function the API client uses to read the selected org.
 *
 * @param getter - Returns the current org code, or null
 */
export const setSelectedOrgGetter = (getter: OrgGetter): void => {
	orgGetter = getter;
};
